<template>
  <v-card class="pa-3">
    <v-card-title class="headline pt-0 pl-0">Copy Season Routes</v-card-title>

    <div v-if="!showConfirmView">
      <v-layout row class="mb-3">
        <div class="font-weight-medium mr-2 pt-2">Current Season:</div>
        <div class="pt-2">{{ selectedSeason }}</div>

        <div class="font-weight-medium mx-2 pt-2">
          Copy To:
        </div>
        <v-select
          class="pt-0"
          v-model="copyToSeason"
          label="Season"
          :items="seasons"
          hide-details
          style="max-width: 200px;"
        ></v-select>
        <v-select
          class="pt-0 ml-2"
          v-model="term"
          label="Term"
          :items="terms"
          hide-details
          style="max-width: 150px;"
        ></v-select>
        <v-menu
          v-model="dateFromPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFrom"
              :value="dateFrom"
              label="Route Schedule Start Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
              class="mt-0 pt-0 ml-4 width-220"
              hide-details
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateFrom"
            @change="dateFromChanged"
          ></v-date-picker>
        </v-menu>
        <v-menu
          v-model="dateToPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateTo"
              :value="dateTo"
              label="Route Schedule End Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
              class="mt-0 pt-0 ml-4 width-220"
              hide-details
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateTo"
            @change="dateToChanged"
          ></v-date-picker>
        </v-menu>
        <v-spacer></v-spacer>
      </v-layout>

      <v-divider></v-divider>
      <v-card-text class="py-2 px-0 mt-3 scroll mx-2" style="height: 500px;">
        <div
          v-for="(route, index) in routes.filter((r) => r.newSchedule)"
          class="student-line"
        >
          <v-layout row class="mb-2 mt-0">
            <div style="width: 32%;" class="mr-3">
              <div class="font-weight-regular">
                {{ route.description }}
              </div>
              <div class="font-weight-medium">
                {{ route.routeIdentifier }}
              </div>
              <div class="caption">
                {{
                  route.timeStart +
                    " - " +
                    route.routeIdentifier +
                    " - " +
                    route.groupBy
                }}
              </div>
            </div>
            <!-- <div class="width-100"></div> -->

            <v-autocomplete
              class="mx-2 width-250"
              label="Driver / Bus"
              v-model="route.newSchedule.driver_bus"
              :items="driver_busList.map((b) => b.displayName)"
              ref="newRouteDriver_bus"
              :rules="[rules.required]"
              hide-details
            ></v-autocomplete>
            <v-menu
              v-model="route.newSchedule.dateFromPickerMenu"
              :close-on-content-click="true"
              offset-y
              full-width
              prepend-icon="mdi-currency-usd"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="route.newSchedule.dateFrom"
                  :value="route.newSchedule.dateFrom"
                  label="Route Schedule Start Date"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-on="on"
                  class="mb-0 pb-0 ml-4 mr-3 width-250"
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="route.newSchedule.dateFrom"
              ></v-date-picker>
            </v-menu>
            <v-menu
              v-model="route.newSchedule.dateToPickerMenu"
              :close-on-content-click="true"
              offset-y
              full-width
              prepend-icon="mdi-currency-usd"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="route.newSchedule.dateTo"
                  :value="route.newSchedule.dateFrom"
                  label="Route Schedule End Date"
                  prepend-icon="mdi-calendar"
                  clearable
                  v-on="on"
                  class="mb-0 pb-0 ml-4 mr-3 width-250"
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="route.newSchedule.dateTo"></v-date-picker>
            </v-menu> </v-layout
          ><v-divider
            class="mt-0 mb-2 pb-1"
            v-if="index + 1 < routes.filter((r) => r.newSchedule).length"
            :key="index"
          ></v-divider>
        </div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn dark color="default" @click="closeDialog()">Cancel</v-btn>
        <v-btn
          :loading="processing"
          color="success"
          @click="continueToConfirm()"
        >
          Continue
        </v-btn>
      </v-card-actions>
    </div>

    <div v-else>
      <div
        class="headline font-weight-regular text-warning mb-4 text-xs-center"
      >
        Please confirm the details below
      </div>
      <v-card-text class="pa-2 mt-3 scroll" style="height: 500px;">
        <div
          height="50"
          v-for="(route, index) in routes.filter((r) => r.newSchedule)"
        >
          <v-layout row class="font-weight-regular">
            <div style="width: 32%;" class="mr-3">
              <div class="font-weight-regular">
                {{ route.description }}
              </div>
              <div class="font-weight-medium">
                {{ route.routeIdentifier }}
              </div>
              <div class="caption">
                {{
                  route.timeStart +
                    " - " +
                    route.routeIdentifier +
                    " - " +
                    route.groupBy
                }}
              </div>
            </div>
            <div class="width-100"></div>

            <div class="mx-3 text-xs-center pt-4 width-250">
              {{ route.newSchedule.driver_bus }}
            </div>

            <div class="mx-3 pt-4 text-xs-center width-250">
              {{ "Start: " + route.newSchedule.dateFrom }}
            </div>
            <div class="mx-3 pt-4 text-xs-center width-250">
              {{ "End: " + route.newSchedule.dateTo }}
            </div>
          </v-layout>
          <v-divider
            class="mt-2 mb-2 pb-1"
            v-if="index + 1 < routes.filter((r) => r.newSchedule).length"
            :key="index"
          ></v-divider>
        </div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn dark color="default" @click="closeDialog()">Cancel</v-btn>
        <v-btn color="default" outline @click="showConfirmView = false"
          >Back</v-btn
        >
        <v-btn :loading="processing" color="success" @click="save()">
          Save
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>
<script>
import moment from "moment";
import { getDomain, sum, toISOLocal } from "../../utils/helpers.js";

export default {
  props: {
    routes: Array,
    reload: Function,
    closeDialog: Function,
    seasons: Array,
    terms: Array,
    selectedSeason: String,
    selectedTerm: String,
  },
  data() {
    return {
      copyToSeason: "",
      processing: false,
      reasons: [],
      dateFromPickerMenu: false,
      dateToPickerMenu: false,
      dateFrom: "",
      dateTo: "",
      driver_busList: [],
      term: "",

      showConfirmView: false,

      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  async created() {
    this.loadReasons();
  },
  computed: {},
  watch: {
    routes(newValue, oldValue) {
      this.loadDriverBusList();

      this.$forceUpdate();
    },
    selectedTerm(newValue) {
      this.term = newValue;
    },
  },
  methods: {
    async loadDriverBusList() {
      const response = await this.$http.get("api/route/getDriverBusList");

      this.driver_busList = response
        .map((driverBus) => {
          driverBus.displayName =
            (driverBus.nameH ? driverBus.nameH : driverBus.name) +
            " - " +
            driverBus.busNumber;

          return driverBus;
        })
        .sort((a, b) => {
          const busNumberA = parseInt(a.busNumber) || 0;
          const busNumberB = parseInt(b.busNumber) || 0;
          return busNumberA - busNumberB;
        });

      this.$forceUpdate();
    },
    async loadReasons() {
      this.reasons = await this.$http.get(
        "api/driverAbsent/GetDriverAbsentReasons"
      );
    },
    dateFromChanged(value) {
      this.routes.forEach((r) => (r.newSchedule.dateFrom = value));
    },
    dateToChanged(value) {
      this.routes.forEach((r) => (r.newSchedule.dateTo = value));
    },
    hasInvalidScheduleDates() {
      return this.routes.some(
        (r) => new Date(r.newSchedule.dateFrom) > new Date(r.newSchedule.dateTo)
      );
    },
    continueToConfirm() {
      if (!this.copyToSeason) {
        return this.$notify({
          group: "notification",
          text: "Missing Season",
          type: "error",
        });
      }

      if (!this.term) {
        return this.$notify({
          group: "notification",
          text: "Missing Term",
          type: "error",
        });
      }

      if (this.hasInvalidScheduleDates()) {
        return this.$notify({
          group: "notification",
          text: "Start Date cannot be after End Date",
          type: "error",
        });
      }

      this.showConfirmView = true;
    },
    async save() {
      try {
        this.processing = true;

        await this.$http.post("api/route/copyRoutes", {
          routes: this.routes.map((route) => {
            const driverBus = this.driver_busList.find(
              (d) => d.displayName == route.newSchedule.driver_bus
            );

            let schedule;

            if (driverBus && route.newSchedule.dateFrom) {
              schedule = {
                driver_Bus_ID: driverBus ? driverBus.id : "",
                term: this.term,
                dateFrom: route.newSchedule.dateFrom,
                dateTo: route.newSchedule.dateTo,
              };
            }

            return {
              buildings: route.buildings,
              color: route.color,
              description: route.description,
              direction: route.direction,
              goeNotRequired: route.goeNotRequired,
              grades: route.grades,
              groupBy: route.groupBy,
              routeIdentifier: route.routeIdentifier,
              term: this.term,
              timeStart: route.timeStart,
              weekDays: route.weekDays,
              season: this.copyToSeason,
              schedule: schedule,
            };
          }),
        });

        this.$notify({
          group: "notification",
          text: "Routes Saved",
          type: "success",
        });

        this.processing = false;
        this.showConfirmView = false;

        this.closeDialog();
        this.reload();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    getReasonID(reason) {
      const data = this.reasons.find((r) => r.reason == reason);

      return data ? data.id : null;
    },
  },
};
</script>
<style>
.scroll-container {
  height: 100%;
  overflow-y: scroll;
  backface-visibility: hidden;
}
.substitute-option {
  font-size: 12px;
  background-color: purple;
  color: #fff;
  width: fit-content;
  padding: 3px;
  margin-bottom: 2px;
  border-radius: 5px;
}
</style>
